<script setup lang="ts">
const props = defineProps({
    metaCurrentPage: {
        type: Number,
        default: 1,
    },
    metaTotalPage: {
        type: Number,
        default: 1,
    },
    linkPrev: {
        type: String,
        default: "",
    },
    linkNext: {
        type: String,
        default: "",
    },
});
</script>

<template>
    <div v-if="metaTotalPage > 1" class="mt-14 text-center md:text-right">
        <NuxtLink :to="linkPrev">
            <div
                class="-mb-2 inline-block rounded-full border bg-white px-3 py-2 shadow-lg"
                :class="linkPrev ? 'cursor-pointer' : ''"
            >
                <img
                    :src="linkPrev ? '/images/fa/chevron-left-regular.svg' : '/images/fa/chevron-left-duotone.svg'"
                    class="w-2"
                />
            </div>
        </NuxtLink>
        <div class="inline-block px-4">Page {{ metaCurrentPage }} of {{ metaTotalPage }}</div>
        <NuxtLink :to="linkNext">
            <div
                class="-mb-2 inline-block rounded-full border bg-white px-3 py-2 shadow-lg"
                :class="linkNext ? 'cursor-pointer' : ''"
            >
                <img
                    :src="linkNext ? '/images/fa/chevron-right-regular.svg' : '/images/fa/chevron-right-duotone.svg'"
                    class="w-2"
                />
            </div>
        </NuxtLink>
    </div>
</template>

<style scoped></style>
